import React, { useEffect } from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';
import { Container } from '@fiverr-private/layout_components';
import { useMonitoring } from '@fiverr-private/seller_pages_toolbox';
import { WorkExperience as WorkExperienceComponent } from '@fiverr-private/seller_components';
import { useWorkExperiencesData } from '../../hooks/useWorkExperiencesData';

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the WorkExperience Component');
    logger.error(err, {
        cause: originalError,
    });
};

export const WorkExperience = () => {
    const { fireEvents, Providers } = useMonitoring();
    const { workExperiences, showWorkExperience } = useWorkExperiencesData();

    useEffect(() => {
        if (showWorkExperience) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: 'Seller work experience exists',
                },
            });
        }
    }, [showWorkExperience, Providers.Mixpanel, fireEvents]);

    if (!showWorkExperience) {
        return null;
    }

    return (
        <ErrorBoundary onError={onRenderError}>
            <Container width="100%">
                <WorkExperienceComponent workExperiences={workExperiences} />
            </Container>
        </ErrorBoundary>
    );
};
